export default {
      id: "caret-down-usage",
      viewBox: "0 0 15 9",
      url: "../../assets/" + "sprite.svg#caret-down-usage",
      toString: function () {
        return this.url;
      }
    }